import React from 'react';
import { Button } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import { modals } from 'ducks';

import apiFetch from 'utils/apiFetch';
import UnorderedList from 'components/shared/UnorderedList';
import ModalComponent from '../../ModalComponent';
import registeredComponent from '../../../utils/registeredComponent';
import './styles/BulkContractCreation.scss';
import Routes from '../../../../routes';

const ACTIONS = [
  'Verify payment plans are correct and have been tested',
  <a className='contract-fees' target='_blank' href={Routes.contract_fees_path()}>Verify Contract Fees and Rules</a>,
  'Preview the contract via the contact record'
];

const INFOS = [
  'Only contracts not yet submitted will be created',
  'Any in-progress contract will return to the generated state and any edits will be lost',
  'Submitted contracts will not change or be regenerated'
];

const PAYMENT_PLAN_ITEMS = [
  'Regenerating this contract will stop the current payment plan if there is one',
  'Once the new contract is submitted, the payment plan will resume based on selections made on the contract',
  'All changes to the payment plan or fee structure should be carefully reviewed'
];

class ContractGeneration extends React.Component {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.state = {
      errorContacts: [],
      errorMessage: undefined,
      warningContacts: [],
      warningMessage: undefined,
      loading: false,
      enable: false,
      count: undefined
    };
  }

  componentDidMount() {
    let { ids, bulk } = this.props;

    if (bulk) {
      this.setState({ loading: true });
      apiFetch.post(this.state, '', { ids }, { baseUrl: Routes.count_recipients_path('generate') })
        .then(response => {
          const errs = [];
          const warns = [];
          const errors = response.errors[0];
          const warnings = response.warnings[0];
          let errMessage;
          let warnMessage;

          if (warnings) {
            warnMessage = warnings.message;
            for (const [k, v] of warnings.contacts) {
              warns.push(<a href={Routes.contact_path(`${k}`)}>{`${v}`}</a>);
            }
          }

          if (errors) {
            errMessage = errors.message;
            for (const [k, v] of errors.contacts) {
              errs.push(<a href={Routes.contact_path(`${k}`)}>{`${v}`}</a>);
            }
          }

          this.setState({
            errorContacts: errs,
            warningContacts: warns,
            errorMessage: errMessage,
            warningMessage: warnMessage,
            loading: false,
            count: response.count,
            enable: !!response.enable
          });
        });
    } else {
      this.setState({
        enable: true
      });
    }
  }

  onSubmit() {
    const { workflow, bulk, ids } = this.props;
    const title = workflow === 'pending' ? 'Generation' : 'Regeneration';
    const pass = workflow === 'pending' ? 'GENERATE' : 'REGENERATE';

    ReactComponent.dispatch(
      modals.actions.show('ContractGenerationVerification', {
        title,
        pass,
        workflow,
        bulk,
        ids
      })
    );
  }

  render() {
    const {
      loading,
      enable,
      errorMessage,
      errorContacts,
      warningMessage,
      warningContacts,
      count
    } = this.state;
    const { workflow, bulk, billing } = this.props;
    const generating = workflow === 'pending';
    const title = generating ? 'Generation' : 'Regeneration';

    return (
      <div>
        <ModalComponent
          title={`Contract ${title}`}
          buttons={[<Button className='btn' disabled={!enable} onClick={() => this.onSubmit()}>Next</Button>]}
        >
          <div className='contract-generation-first-step-modal'>

            <UnorderedList
              message='Important'
              icon='info-circle'
              reface='Before generating contracts, please do the following:'
              actions={ACTIONS}
              extraClassMessage='danger'
            />

            {bulk && (
              <UnorderedList
                message='About Contract Generation'
                className='contract-bulk-about'
                actions={INFOS}
              />
            )}

            {billing && !generating && (
              <div>
                <UnorderedList
                  message='About Payment Plans'
                  icon='info-circle'
                  actions={PAYMENT_PLAN_ITEMS}
                  extraClassMessage='danger'
                />
              </div>
            )}

            {loading && (
              <div className='contract-bulk-loading'>
                <FontAwesome name='spinner' spin />
                Loading Contract Info...
              </div>
            )}

            {errorContacts.length > 0 && (
              <UnorderedList
                message={errorMessage}
                className='danger'
                extraClassMessage='smaller'
                actions={errorContacts}
              />
            )}

            {warningContacts.length > 0 && (
              <UnorderedList
                message={warningMessage}
                className='warning'
                extraClassMessage='smaller'
                actions={warningContacts}
              />
            )}

            {count && <div className='contract-bulk-count-message'>{count}</div>}
          </div>
        </ModalComponent>

      </div>
    );
  }
}

export default registeredComponent('ContractGeneration')(ContractGeneration);
